var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 117,
    viewBox: "0 0 96 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.9147 92.7899C96.8262 96.6962 96.8647 103.119 92.3455 106.303C85.6813 110.998 78.0775 114.273 70.0068 115.876C58.6436 118.133 46.8654 116.975 36.1616 112.547C25.4577 108.119 16.309 100.621 9.87228 91.0008C3.43558 81.3806 7.13554e-07 70.0702 0 58.5C-7.13553e-07 46.9298 3.43558 35.6194 9.87228 25.9992C16.309 16.3789 25.4577 8.8808 36.1616 4.45307C46.8654 0.0253485 58.6436 -1.13315 70.0068 1.12409C78.0775 2.72729 85.6813 6.00245 92.3454 10.6971C96.8647 13.8808 96.8262 20.3038 92.9147 24.2101L88.5508 28.568C84.6467 32.467 78.3533 32.2906 73.4501 29.7602C70.7682 28.3762 67.8913 27.3658 64.8984 26.7713C58.6146 25.5231 52.1013 26.1637 46.1821 28.6122C40.2629 31.0607 35.2036 35.2072 31.6442 40.5271C28.0847 45.8471 26.1848 52.1017 26.1848 58.5C26.1848 64.8983 28.0847 71.1529 31.6442 76.4729C35.2037 81.7929 40.2629 85.9393 46.1821 88.3878C52.1013 90.8363 58.6146 91.4769 64.8984 90.2287C67.8913 89.6342 70.7682 88.6238 73.4501 87.2398C78.3533 84.7094 84.6467 84.533 88.5508 88.4319L92.9147 92.7899Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logoWhite.adb06a1ad9d14b44ac8daf38dc257a97.svg";
export { ForwardRef as ReactComponent };